<template>
    <div>
        <div
            class="row"
            style="margin-bottom: 15px">
            <div class="col-md-12">
                <div style="margin-left: 20px; font-size: 12px">
                    <i
                        class="fa fa-hand-pointer"
                        style="color: gray"></i>

                    <span v-for="(folder, index) of selectedFolders">
                        <span
                            class="bread-crumb-name"
                            @click="onClickFolderHeader(folder.id)"
                            >{{ folder.name }}</span
                        >
                        <span v-if="index !== selectedFolders.length - 1">></span>
                    </span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div v-if="!folderTree.folders.length && !folderTree.presentations.length">
                    <i style="padding-left: 20px">Maak de eerste les of folder aan </i>
                </div>

                <ul
                    class="list-group"
                    v-else>
                    <li
                        class="list-group-item"
                        v-for="folder in folderTree.folders"
                        @click="onClickFolder(folder.id)">
                        <i
                            class="fa fa-folder"
                            style="margin-right: 15px"></i>
                        {{ folder.name }}
                        <span class="float-right">
                            <button class="btn btn-sm btn-inverse-primary"><i class="fa fa-eye"></i></button>
                            <button
                                class="btn btn-sm btn-inverse-primary"
                                @click.stop
                                @click="onClickUpdateFolder(folder)"
                                :id="'folder-' + folder.id">
                                <i class="fa fa-wrench"></i>
                            </button>
                            <button
                                class="btn btn-sm btn-inverse-danger"
                                @click.stop
                                @click="onclickRemoveFolder(folder.id)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </span>
                    </li>
                    <li
                        class="list-group-item"
                        v-for="presentation in folderTree.presentations">
                        <span>{{ presentation.name }}</span>
                        <span class="float-right">
                            <button
                                class="btn btn-sm btn-inverse-primary"
                                @click="onClickpresentationView(presentation.id)">
                                <i class="fa fa-chalkboard-teacher"></i>
                            </button>
                            <button
                                class="btn btn-sm btn-inverse-primary"
                                @click="onClickpresentation(presentation.id)">
                                <i class="fa fa-wrench"></i>
                            </button>
                            <button
                                class="btn btn-sm btn-inverse-primary"
                                v-b-modal="'copy-presentation-modal-' + presentation.id"
                                @click="onClickCopypresentation(presentation)">
                                <i class="fa fa-copy"></i>
                            </button>
                            <button
                                class="btn btn-sm btn-inverse-danger"
                                @click="onclickRemovepresentation(presentation.id)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </span>
                    </li>
                </ul>

                <design-2021-presentation-index-update-folder-modal-component
                    ref="updateFolderModal"
                    @folder-updated="folderUpdated($event)">
                </design-2021-presentation-index-update-folder-modal-component>

                <design-2021-presentation-index-copy-presentation-modal-component
                    ref="copypresentationModal"
                    @presentation-copied="presentationCopied($event)">
                </design-2021-presentation-index-copy-presentation-modal-component>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-presentation-index-tree-component',
    props: ['folderTree', 'selectedFolders', 'foldersTree'],
    methods: {
        onClickFolder(id) {
            this.$emit('folder-clicked', id);
        },
        onClickFolderHeader(id) {
            this.$emit('folder-header-clicked', id);
        },
        onClickpresentationView(id) {
            window.location.href = baseUrl + '/presentation/' + id;
        },
        onClickpresentation(id) {
            window.location.href = baseUrl + '/presentation/' + id + '/edit';
        },
        presentationUpdated(presentation) {
            this.$emit('presentation-updated', presentation);
        },
        presentationCopied(presentation) {
            this.$emit('presentation-copied', presentation);
        },
        folderUpdated(presentation) {
            this.$emit('folder-updated', presentation);
        },
        onclickRemovepresentation(id) {
            this.alert.confirm('Les verwijderen', 'Weet je zeker dat je deze les wilt verwijderen?').then((confirm) => {
                if (confirm) {
                    this.$emit('presentation-removed', id);
                }
            });
        },
        onclickRemoveFolder(id) {
            this.alert
                .confirm('Folder verwijderen', 'Weet je zeker dat je deze folder wilt verwijderen?')
                .then((confirm) => {
                    if (confirm) {
                        this.$emit('folder-removed', id);
                    }
                });
        },
        onClickUpdateFolder(folder) {
            this.$refs['updateFolderModal'].open(folder);
        },
        onClickCopypresentation(folder) {
            this.$refs['copypresentationModal'].open(folder, this.foldersTree, this.selectedFolders);
        },
    },
};
</script>

<style scoped>
li {
    cursor: pointer;
}

li:hover {
    background-color: lightgray;
}

.bread-crumb-name {
    margin-right: 5px;
    margin-left: 10px;
    cursor: pointer;
    color: gray;
}
.bread-crumb-name:hover {
    color: black;
}

.list-group-item {
    line-height: 2.3;
}
</style>
